import React from 'react'
import { useNavigate } from 'react-router-dom';

const UnauthorizedPrivate = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/'); 
  };

  const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '80vh', 
    textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f8f9fa',
    color: '#333',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    maxWidth: '600px',
    margin: '20px auto',
  },
  icon: {
    fontSize: '4em',
    marginBottom: '20px',
    color: '#dc3545', 
  },
  title: {
    fontSize: '2.5em',
    marginBottom: '15px',
    color: '#dc3545',
  },
  message: {
    fontSize: '1.1em',
    marginBottom: '30px',
    lineHeight: '1.6',
    maxWidth: '500px',
  },
  button: {
    padding: '12px 25px',
    fontSize: '1em',
    color: '#fff',
    backgroundColor: '#007bff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    '&:hover': {
      backgroundColor: '#0056b3',
    },
  },
};

  return (
    <div style={styles.container}>
      {/* Puedes añadir un icono o imagen aquí */}
      <div style={styles.icon}>⚠️</div>
      <h1 style={styles.title}>Error 403 - Prohibido</h1>
      <p style={styles.message}>
        No tienes permiso para acceder a esta página. Por favor, verifica tus credenciales o regresa a la página de inicio.
      </p>
      <button onClick={handleGoHome} style={styles.button}>
        Ir a la Página de Inicio
      </button>
    </div>
  )
}

export default UnauthorizedPrivate